"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillEvaluation = void 0;
var SyncSkillEvaluation_1 = require("./SyncSkillEvaluation");
var AsyncSkillEvaluation_1 = require("./AsyncSkillEvaluation");
var SkillEvaluation = /** @class */ (function (_super) {
    __extends(SkillEvaluation, _super);
    function SkillEvaluation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "SkillEvaluation";
        _this.syncEval = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new SyncSkillEvaluation_1.SyncSkillEvaluation();
            config(entity);
            return "syncEval(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.asyncEval = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new AsyncSkillEvaluation_1.AsyncSkillEvaluation();
            config(entity);
            return "asyncEval(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return SkillEvaluation;
}(Array));
exports.SkillEvaluation = SkillEvaluation;
//# sourceMappingURL=SkillEvaluation.js.map